// @ts-check

// @ts-ignore -> html modules not supported
import html from './incident-list.template.html';

/**
 */
export class IncidentListController {

  /** @type {import('./status-page.module').IStatusPageService} */
  service;

  incidents = [];

  /**
   * @param {import('./status-page.module').IStatusPageService} StatusPageService
   */
  constructor(StatusPageService) {
    this.service = StatusPageService;
  }

  $onInit() {
    console.log("IncidentListControlller onInit:");

    this.service.getIncidents()
      .then(_ => {
        this.incidents = _;
      });
  }
}

export default {
  template: html,
  controller: IncidentListController,
  bindings: {
    isVisible: "<",
  }
};